import { keepPreviousData, useQuery } from "@tanstack/react-query";
import getAppointmentTypeList from "api/bookAppointmentOnline/get-appointment-type-list";

const BOOK_ONLINE_APPOINTMENT_TYPE_LIST_KEY = "book_online_appointment_type_list"
export default function useGetAppointmentTypeOnlineOptionList(doctorId?: string) {
    return useQuery({
        queryKey: [BOOK_ONLINE_APPOINTMENT_TYPE_LIST_KEY, doctorId],
        queryFn: () => getAppointmentTypeList(doctorId),
        placeholderData: keepPreviousData,
    });
}
